export default __webpack_public_path__ + "static/media/carousel-2.5da925ef.jpg";